import React, { useEffect, useState } from "react";
import { ButtonType } from "@components/atoms/Button/types";
import { useTranslation } from "react-i18next";
import PopUp from "@components/molecules/PopUp";
import { ButtonAction } from "@scenes/onboarding/types";
import { messageType } from "@components/molecules/PopUp/types";
import { removeSecureStoreItems } from "@utils/index";

interface PopupAlertProps {
  route: any;
  isRemovableFromStorage: boolean;
}

export const PopupAlert: React.FC<PopupAlertProps> = ({
  route,
  isRemovableFromStorage,
}) => {
  const { t } = useTranslation();

  const [successPopupData, setSuccessPopupData] = useState({
    show: false,
    titleMessage: "",
    messageType: "",
    contentBody: { html: "" },
    actionButtons: [] as ButtonAction[],
  });

  useEffect(() => {
    if (route?.params?.accountDeleted) {
      setSuccessPopupData({
        show: true,
        titleMessage: t("deleteAccount.popUp.success.title.text"),
        messageType: messageType.Success,
        contentBody: {
          html: t("deleteAccount.popUp.success.discription.text"),
        },
        actionButtons: [
          {
            type: ButtonType.primary,
            title: t("deleteAccount.popUp.success.button.close.text"),
            onPressAction: () =>
              setSuccessPopupData((prev) => ({ ...prev, show: false })),
          },
        ],
      });

      if (isRemovableFromStorage) {
        removeSecureStoreItems(["username", "password"]);
      }
    }
  }, [route?.params?.accountDeleted, isRemovableFromStorage]);

  useEffect(() => {
    if (route?.params?.accountDeleted) {
      setSuccessPopupData({
        show: true,
        titleMessage: t("deleteAccount.popUp.success.title.text"),
        messageType: messageType.Success,
        contentBody: {
          html: t("deleteAccount.popUp.success.discription.text"),
        },
        actionButtons: [
          {
            type: ButtonType.primary,
            title: t("deleteAccount.popUp.success.button.close.text"),
            onPressAction: () =>
              setSuccessPopupData((prev) => ({ ...prev, show: false })),
          },
        ],
      });
    }
  }, [route?.params?.accountDeleted]);

  return (
    successPopupData.show && (
      <PopUp
        type={successPopupData.messageType}
        title={successPopupData.titleMessage}
        buttons={successPopupData.actionButtons}
        HtmlSource={successPopupData.contentBody}
        styleKey="Body-R"
      />
    )
  );
};
